// extracted by mini-css-extract-plugin
export default {"reportContainer":"reportContainer___FIuUz"};